// extracted by mini-css-extract-plugin
export var hideEditor = "_jm-2";
export var infoIcon = "_jm-3";
export var label = "_jm-1";
export var labelContainer = "_jm-0";
export var readonlyText = "_jm-4";